/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cta_NoteInputs */

const en_faq_cta_note = /** @type {(inputs: Faq_Cta_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 30-minute conversation. No technical brief needed.`)
};

const lv_faq_cta_note = /** @type {(inputs: Faq_Cta_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 minūšu saruna. Tehnisks apraksts nav vajadzīgs.`)
};

/**
* | output |
* | --- |
* | "A 30-minute conversation. No technical brief needed." |
*
* @param {Faq_Cta_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_cta_note = /** @type {((inputs?: Faq_Cta_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cta_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_cta_note(inputs)
	return en_faq_cta_note(inputs)
});